import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { checkAuth, clearCookieValue } from '../utils';

const PrivateRoutes = () => {
  const navigate = useNavigate();
  const isUserAuthorized = checkAuth();
  useEffect(() => {
    if (!isUserAuthorized) {
      clearCookieValue('_session_id'); // Clear the token from cookies
      navigate('/', { replace: true }); // Navigate to the login page
      // toast.error('user has been logged out!');
    }
  }, [isUserAuthorized, navigate]);
  return isUserAuthorized ? <Outlet /> : null;
};

export default PrivateRoutes;
